module.exports = __webpack_public_path__ + "static/media/check.e94fc3d0.svg";